import { useFormik } from "formik";
import React from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { useNavigate } from "react-router-dom";
import api from "../../api/auth_api";
import { SVG } from "../../assets/SVG/SVG";
import * as slides from "../../component/Carousel/CarousalSlides";
import Carousel from "../../component/Carousel/Carousel";
import { Button, CustomInput, Label } from "../../component/common";
import { Valid } from "../../utils/Validation";
import { cn } from "../../utils/lib";

const SignUp: React.FC = () => {
  const [errorMsg, setErrorMessage] = React.useState("");
  const [phErrorMsg, setPhErrorMessage] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [countryCode, setCountryCode] = React.useState("");
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: { email: "" },
    validationSchema: Valid.email,
    validateOnBlur: true,
    onSubmit: async (values) => {
      setPhErrorMessage("");
      var ph;
      if (phone !== undefined && countryCode !== "") {
        ph = phone.replace("+" + countryCode, "");
        if (ph !== "") {
        } else {
          setPhErrorMessage("Please enter the valid Phone number");
          return;
        }
      } else {
        setPhErrorMessage("Please enter the valid Phone number");
        return;
      }
      if (ph.length >= 10 && ph.length <= 15) {
      } else {
        setPhErrorMessage("Mobile number must have 10 to 15 digits");
        return;
      }
      setErrorMessage("");
      const data = {
        email: values.email.toLowerCase(),
        mobile: ph!,
        mobile_country_code: countryCode,
      };
      const res = await api.signUp(data);
      res.data.success
        ? navigate("/registration_success", { replace: true })
        : setErrorMessage(res.data.msg);
    },
  });

  function handlechange(e: any) {
    setPhErrorMessage("");
    setPhone(e);
  }

  function handleBlur(e: any) {
    setPhErrorMessage("");
    const len = e.target.value.split(" ").length;
    const c = e.target.value.split(" ");
    const cc = c[0].split("+");
    setCountryCode(cc[1]);
    const ph = e.target.value.substring(e.target.value.indexOf(" ") + 1);
    if (len > 1 && ph !== "") {
      if (ph.length >= 10 && ph.length <= 15) {
      } else {
        setPhErrorMessage("Mobile number must have 10 to 15 digits");
        return;
      }
    } else {
      setPhErrorMessage("Please enter the valid Phone number");
    }
  }

  return (
    <div className=" flex  justify-center items-center max-h-screen">
      <div className=" flex justify-center items-center h-screen lg:w-1/2">
        <div className="w-3/6 flex flex-col gap-2">
          <SVG.LogoDark />
          <p className="text-xl mt-4 font-semibold">
            Welcome, Let's get started.
          </p>
          <p className="text-sm text-gray-400 mb-4">
            To begin, tell us a bit about yourself
          </p>
          {errorMsg && <div className="error text-center ">{errorMsg}</div>}
          <form onSubmit={formik.handleSubmit} autoComplete="off">
            <div className="mb-2">
              <CustomInput
                type="text"
                label="Business Email"
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                isError={!!formik.touched.email && !!formik.errors.email}
                errorMessage={formik.errors.email}
              />
            </div>
            <div className="mb-4">
              <Label text="Mobile Number" className="mb-1.5" />
              <PhoneInput
                defaultCountry="IN"
                international
                countryCallingCodeEditable={false}
                initialValueFormat="national"
                name="phone"
                value={phone}
                onBlur={handleBlur}
                onChange={handlechange}
                className={cn("rounded-lg border py-2 px-4", phErrorMsg !== "" ? "border-red-500" : " border-gray-300 ")}
                autoComplete="off"
              />
              {phErrorMsg && <div className="text-[9px] mt-2 text-red-500">{phErrorMsg}</div>}
            </div>
            <Button
              type="submit"
              text={"Sign Up"}
              className="w-full"
            />
          </form>
          <div className="mt-4">
            <span className="text-input-label">Already have an account? </span>
            <span
              onClick={() => navigate("/signin")}
              className="hover:underline text-button-primary"
            >
              Sign In
            </span>
          </div>
        </div>
      </div>
      <div className="w-1/2 h-screen hidden lg:flex lg:justify-center lg:items-center  ">
        <div className="onboard-box">
          <Carousel slides={slides.slides} />
        </div>
      </div>
    </div>
  );
};

export default SignUp;



